import WHY from '../content/why';
import PhotoBanner from './PhotoBanner';
import Reveal from './Reveal';

export default function WhyBanner() {
  return (
    <PhotoBanner
      id="about" labelledBy="why-h" image="/images/why-bg.jpg" alt="Team working around a table, seen from above"
      overlay="linear-gradient(90deg, rgba(32,30,29,.9) 0%, rgba(32,30,29,.7) 50%, rgba(32,30,29,.35) 100%)"
    >
      <div className="pb-[clamp(40px,5vw,56px)] pt-banner-top">
        <Reveal>
          <div className="eyebrow">Why ISL Tech</div>
          <h2 id="why-h" className="mt-5 max-w-[900px] text-banner">Engineers first. <span className="text-accent">No middle layer.</span></h2>
          <p className="pretty mt-6 max-w-[500px] text-lead text-neutral-200">You talk to the people writing the code. A small senior team, working in your time zone.</p>
        </Reveal>
        <ul className="mt-[clamp(64px,8vw,104px)] grid border-t-2 border-rule-light" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))' }}>
          {WHY.map(w => {
            const Icon = w.icon;
            return (
              <Reveal as="li" key={w.title} className="pb-2 pr-6 pt-6">
                <Icon size={26} aria-hidden="true" className="text-accent" />
                <h3 className="mt-[18px] text-[21px] leading-[1.1] tracking-[-0.02em]">{w.title}</h3>
                <p className="pretty mt-2 text-[15px] text-neutral-300">{w.desc}</p>
              </Reveal>
            );
          })}
        </ul>
      </div>
    </PhotoBanner>
  );
}
